import { Clipboard } from '@angular/cdk/clipboard';
import { ChangeDetectorRef, Component, computed, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Business, getFullAddress, License } from 'src/model/business';
import { Contact } from 'src/model/contact.model';
import { Customer } from 'src/model/customer.model';
import { BusinessService } from 'src/services/business.service';
import { ContactService } from 'src/services/contact.service';
import { CustomerService } from 'src/services/customer.service';
import { DocusealService } from 'src/services/docuseal.service';
@Component({
	selector: 'app-guarantor-agreement-form',
	standalone: false,
	templateUrl: './guarantor-agreement-form.component.html',
	styleUrl: './guarantor-agreement-form.component.scss'
})
export class GuarantorAgreementFormComponent implements OnInit {
	private activatedRoute = inject(ActivatedRoute);
	protected sharedService = inject(SharedService);
	private customerService = inject(CustomerService);
	private contactService = inject(ContactService);
	private businessService = inject(BusinessService);
	private docusealService = inject(DocusealService);
	private clipboard = inject(Clipboard);
	private cdr = inject(ChangeDetectorRef);

	selectedCustomerID: number;
	selectedCompanyID: number;
	selectedContactID: number;

	customer = signal<Customer>(undefined);
	contact = signal<Contact>(undefined);
	license = signal<License>(undefined);
	business = signal<Business>(undefined);

	dsCustomerLink: string;
	dsContactLink: string;
	// business = computed(() => this.businessStore.businessList().find(b => b.Id == this.license().BusinessId));
	licenseFullAddress = computed(() => getFullAddress(this.license().Address));

	// saksi: string;
	// pegawai: string;

	today: Date;
	amount: number;
	routeSubscription: any;
	includeGuarantorContact: boolean = true;

	ngOnInit(): void {
		this.routeSubscription = this.activatedRoute.paramMap.subscribe(async params => {
			this.selectedCustomerID = +params.get('customerId');
			this.selectedCompanyID = +params.get('companyId');
			this.selectedContactID = +params.get('contactId');
			this.today = new Date();
			this.getData();
		});
	}

	async getData() {
		try {
			const [customer, contact, businesses, license] = await Promise.all([
				this.customerService.getCustomerDetails(this.selectedCustomerID),
				this.contactService.getContactDetails(this.selectedContactID),
				this.businessService.getAllBusinesses({ companyId: this.selectedCompanyID }),
				this.businessService.getLatestLicenseByCompanyId(this.selectedCompanyID)
			]);
			this.customer.set(customer);
			this.contact.set(contact);
			this.business.set(businesses[0]);
			this.license.set(license);
		} catch (err) {
			if (err.status === 404) {
				this.sharedService.openAlert('No active business license, please contact admin to add or renew business license!', ALERT_TYPE.DANGER);
				return;
			}
		}
	}

	async createSignLink(amount: number) {
		let ds = await this.docusealService.getPostGuarantorDocuseal(this.selectedCustomerID, this.selectedContactID, new Date(), amount);
		if (ds) {
			this.dsContactLink = ds.contactLink;
			this.dsCustomerLink = ds.customerLink;

			this.cdr.detectChanges();
		}
	}

	copySignLink(link: string, signParty: string) {
		this.clipboard.copy(`${signParty} Sign: ${link}`);
		this.sharedService.openAlert(`Copied the link for ${signParty}, please send the link to ${signParty}!`, ALERT_TYPE.SUCCESS);
	}
}
